/**
 * @generated SignedSource<<3336ebfcda5cacbe9878109aa93f1d2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionPreview_viewer$data = {
  readonly originalListPricePdpFF: boolean | null;
  readonly " $fragmentType": "PdpSharedAuctionPreview_viewer";
};
export type PdpSharedAuctionPreview_viewer$key = {
  readonly " $data"?: PdpSharedAuctionPreview_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionPreview_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionPreview_viewer",
  "selections": [
    {
      "alias": "originalListPricePdpFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "originalListPricePdp"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"originalListPricePdp\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6d9ec2adaf57e11f07a17204a645ff06";

export default node;
